import { Component, OnDestroy, OnInit } from '@angular/core';
import { UrlHistoryService } from '../../services/url.history.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { AppStateService } from '../../services/app-state.service';
import { AppState } from '../../models/AppState';
import { MessengerService } from '../../services/messenger.service';
import { AuthService } from '../../services/auth.service';
import { skip } from 'rxjs/operators';
import {TranslateService} from "../../services/translate.service";
import {UserSpecificSmartTable} from "../../models/Order";
import {HackUtils} from "../../utils/Utils";
import {OrderService} from "../../services/order.service";
import { CommonModule } from '@angular/common';
import { CircleButtonComponent } from '../buttons/circle-button.component';
import { LoadingSpinnerComponent } from '../ui/loading-spinner-component';
import { PageButtonComponent } from "../buttons/page-button.component";
import { ActionButtonComponent } from "../buttons/action-button.component";
import { LeaveSmartTableDialogComponent } from '../dialogs/leave-smart-table-dialog.component';
import { ModalService } from '../../services/modal.service';
import { PlainButtonComponent } from "../buttons/plain-button.component";

@Component({
  selector: 'app-my-account',
  standalone: true,
  imports: [
    CircleButtonComponent,
    CommonModule,
    LoadingSpinnerComponent,
    PageButtonComponent,
    ActionButtonComponent,
    PlainButtonComponent
],
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.css']
})
export class MyAccountComponent implements OnInit, OnDestroy {
  app: AppState | null = null;
  messengerSDKInfo: string | null = null;
  messengerSDKInfoShort: string | null = null;
  accountType: string | null = null;
  showLogout = true;
  public isLoading: boolean = false;
  private sub: Subscription | undefined;
  private signoutSub: Subscription | undefined;
  smartTable: UserSpecificSmartTable | null = null;

  constructor(private appState: AppStateService, private identityService: UrlHistoryService,
              private router: Router, private messengerService: MessengerService, private authService: AuthService,
              private translate: TranslateService, public orderService: OrderService, private modalService: ModalService ) { }

  ngOnInit(): void {
    this.beginObserving();
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
    this.signoutSub?.unsubscribe();
  }

  private beginObserving() {
    this.sub = this.appState.observeAppState().subscribe(appState => {
      this.app = appState;
      this.messengerSDKInfo = this.messengerService.getMessengerState();
      this.messengerSDKInfoShort = this.messengerSDKInfo?.substring(0, 1);
      this.accountType = appState.order.user_cfg.user_type ?? null;
      this.smartTable = appState.order.user_cfg.smart_table ?? null;
      this.showLogout = true; //appState.order.user_cfg.user_type !== "messenger" || !this.messengerService.inMessenger();
    });
  }

  public async logout() {
    this.isLoading = true;
    if (this.app?.venueId) {
      localStorage.removeItem(`ml_link_${this.app.venueId}`);
    }

    this.signoutSub = this.appState.observeAppState().pipe(skip(1)).subscribe(appState => {
      this.identityService.clearHistory();
      this.router.navigateByUrl(`${this.app?.venueId ?? ''}/signout`, { skipLocationChange: true });
    });
    const r = await this.authService.logout();
  }

  connectMessengerAccount() {
    if (this.app?.venueId) {
      this.router.navigateByUrl(`${this.app.venueId}/connect-messenger`);
    }
  }

  editProfile() {

  }

  back() {
    this.identityService.navigateBack();
  }

  openGdpr() {
    if (this.app?.venueId) {
      this.router.navigateByUrl(`${this.app.venueId}/gdpr`);
    }
    return false;
  }

  getString(s: string, pc = "normal") {
    return this.translate.single(s, pc);
  }

  leaveSmartTable(): void {
    this.modalService.show(LeaveSmartTableDialogComponent, {
      data: {
        title: "Lämna SmartTable?",
        message: "Du har tidigare scannat en QR-kod som är kopplad till en SmartTable, vill du lämna?",
        confirmText: "Lämna",
        abortText: "Avbryt"
      }
    }).subscribe({
      next: result => {
        if (result) {
          console.log('SmartTable lämnat:', result);
        }
      },
      error: err => {
        console.error('Dialogfel:', err);
      }
    });
  }


}
